export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Red.9b7f6ef6.jpg";